import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-carbon">
        <Loader2 className="h-8 w-8 animate-spin text-amber" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
